<mat-spinner
  [color]="color"
  [mode]="value == null ? 'indeterminate' : 'determinate'"
  [value]="value"
  [diameter]="config.sizes[size]"
  [strokeWidth]="config.strokeFor[size]"
></mat-spinner>
